import { render } from "./ModalUploadFiles.vue?vue&type=template&id=fa34c8f0&scoped=true"
import script from "./ModalUploadFiles.vue?vue&type=script&lang=js"
export * from "./ModalUploadFiles.vue?vue&type=script&lang=js"

import "./ModalUploadFiles.vue?vue&type=style&index=0&id=fa34c8f0&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa34c8f0"]])

export default __exports__